import React, { useState, useEffect } from 'react'
import TextInput from 'components/ui/forms/field/text-input/TextInput'
import { Container, Col, Row, ButtonToolbar } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import * as fromActions from 'store/actions/blocks.action'
import { IMainState } from 'store/states'
import styles from './RichText.module.scss'
import Button from 'design-system/button'
import { ButtonVariant, ButtonSizes } from 'design-system/button/src/Button'
import RichTextInput from 'components/ui/forms/field/rich-text-input/RichTextInput'

const config = {
  showCharsCounter: false,
  showWordsCounter: false,
  showXPathInStatusbar: false,
  toolbarAdaptive: false,
  disablePlugins: 'placeholder',
  buttons: 'source,|,bold,italic,underline,strikethrough,|,ul,ol,,outdent,indent,,font,fontsize,brush,|,image,video,table,link,|,align,undo,redo,copyformat',
  height: 300,
}

interface ITextAndImage {
  onCancel: any
  editing: boolean
}

const TextAndImage: React.FC<ITextAndImage> = ({ onCancel, editing }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  // Tuve que separarlos, Judit cambia ambos estados (I don't know why 💁‍♂️)
  const [name, setName] = useState('')
  const [content, setContent] = useState('')
  const { edit } = useSelector(({ blocks }: IMainState) => blocks)

  useEffect(() => {
    setName(edit.name || '')
    setContent(edit.content || '')
  }, [edit])

  const handleOnSave = () => {
    const { id, lessonId } = edit
    dispatch({ type: fromActions.EDIT_RICHTEXT_BLOCK, payload: { name, content, id, lessonId } })
    onCancel()
  }

  return (
    <Container fluid>
      <Row>
        <h1 className={styles.title}>{t(`administration.blocks.type.richText.${editing ? 'edit' : 'new'}`)}</h1>
      </Row>
      <Row>
        <Col xs={6} className={'p-0 pt-3'}>
          <TextInput name={'name'} value={name} label={t('administration.blocks.type.richText.title')} placeHolder={''} onChange={(e: any) => setName(e.target.value)} disabled={false} error={''} />
        </Col>
      </Row>
      <Row>
        <Col xs={12} className={'p-0 pt-3'}>
          <RichTextInput name="description" value={content} label={t('administration.blocks.type.richText.content')} onChange={(value: any) => setContent(value)} config={config} error={''} />
        </Col>
      </Row>
      <ButtonToolbar className="float-right mt-5">
        <Button onClick={onCancel} variant={ButtonVariant.Secondary} size={ButtonSizes.Small}>
          {t('administration.blocks.type.survey.buttons.cancel')}
        </Button>
        <Button size={ButtonSizes.Small} onClick={handleOnSave}>
          {t('administration.blocks.type.survey.buttons.accept')}
        </Button>
      </ButtonToolbar>
    </Container>
  )
}

export default TextAndImage
